/** An account with no teams has nothing to cover, so it is never considered fully covered. */
export const coversEveryTeam = (selectedTeamIds: readonly number[], allTeamIds: readonly number[]): boolean => {
    if (allTeamIds.length === 0) {
        return false;
    }

    const selected = new Set(selectedTeamIds);

    return allTeamIds.every((teamId) => selected.has(teamId));
};
